import { observer } from 'mobx-react';
import GroupParticipantsStore from '../../GroupParticipantsStore/Store';
import Head from '../Head';
import ParticipantsEmpty from './ParticipantsEmpty';

interface Props {
  groupParticipantsStore: GroupParticipantsStore;
  openModal: () => void;
  allParticipantIds: number[];
}

function EmptyTable({ groupParticipantsStore, openModal, allParticipantIds }: Props) {
  return (
    <table className="min-w-full divide-y divide-gray-300">
      <Head
        sorting={groupParticipantsStore.sorting}
        searchParameters={groupParticipantsStore.searchParameters}
      />
      <tbody className="bg-gray-50">
        <tr className="border-dashed border-2 border-gray-300">
          <td colSpan={7}>
            <div className="p-4 flex flex-col justify-center items-center">
              <ParticipantsEmpty openModal={openModal} allParticipantIds={allParticipantIds} />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default observer(EmptyTable);
